// Imports
import { ContentButtonLink } from "../elements/ContentButtonLink";

// Content
export function SimpleContent({ content, className }) {
  return (
    <div className="flex flex-col space-y-5">
      {content?.map((item, index) => {
        switch (item.type) {
          case "text":
            return (
              <div
                key={index}
                className={`content-block ${className}`}
                dangerouslySetInnerHTML={{ __html: item?.text }}
              />
            );
          case "button":
            return (
              <div key={index}>
                <ContentButtonLink item={item} />
              </div>
            );
          default:
            return null;
        }
      })}
    </div>
  );
}
